interface LogoIconProps {
  size?: number
  className?: string
}

export function LogoIcon({ size = 32, className = '' }: LogoIconProps) {
  const scale = size / 40
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M20 0H10C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20H20L30 10L20 0Z"
        transform={`scale(${scale}) translate(0, ${10 / scale})`}
        fill="#374151"
      />
      <path
        d="M30 0H40C45.5228 0 50 4.47715 50 10C50 15.5228 45.5228 20 40 20H30L20 10L30 0Z"
        transform={`scale(${scale}) translate(0, ${10 / scale})`}
        fill="#F97316"
      />
      <path
        d="M22.5 6H32.5L17.5 14H27.5"
        transform={`scale(${scale}) translate(0, ${10 / scale})`}
        stroke="white"
        strokeWidth={2 / scale}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

// Simplified approach: use fixed viewBox
export function LogoMark({ size = 32 }: { size?: number }) {
  const w = size
  const h = size
  return (
    <svg width={w} height={h} viewBox="0 0 160 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M60 20H40C28.9543 20 20 28.9543 20 40C20 51.0457 28.9543 60 40 60H60L80 40L60 20Z" fill="#374151"/>
      <path d="M100 20H120C131.046 20 140 28.9543 140 40C140 51.0457 131.046 60 120 60H100L80 40L100 20Z" fill="#F97316"/>
      <path d="M75 32H95L65 48H85" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

interface LogoProps {
  showText?: boolean
  size?: 'sm' | 'md' | 'lg'
  variant?: 'light' | 'dark' | 'auto'
  className?: string
}

const sizeMap = {
  sm: { icon: 28, text: 'text-sm', gap: 'gap-2' },
  md: { icon: 32, text: 'text-base', gap: 'gap-2.5' },
  lg: { icon: 40, text: 'text-2xl', gap: 'gap-3' },
}

export function Logo({ showText = true, size = 'md', variant = 'auto', className = '' }: LogoProps) {
  const s = sizeMap[size]
  const textColor = variant === 'light'
    ? 'text-white'
    : variant === 'dark'
      ? 'text-slate-900'
      : 'text-[#0d121b] dark:text-white'

  return (
    <div className={`flex items-center ${s.gap} ${className}`}>
      <LogoMark size={s.icon} />
      {showText && (
        <span className={`${s.text} font-bold tracking-tight ${textColor} whitespace-nowrap`}>
          URLzippy
        </span>
      )}
    </div>
  )
}
